import { render, staticRenderFns } from "./StepC.vue?vue&type=template&id=2cdb3f6e&scoped=true"
import script from "./StepC.vue?vue&type=script&lang=js"
export * from "./StepC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb3f6e",
  null
  
)

export default component.exports